// « Introuvable ? » (sections/snk-request-model.liquid) : ouvre le formulaire quand on arrive par l'ancre
// #snk-request-model (lien « demande-nous ce modèle » de la grille), et affiche la confirmation après l'envoi
// (Shopify revient sur la page avec contact_posted=true#SnkRequestForm).
if (!customElements.get('snk-request-model')) {
  customElements.define(
    'snk-request-model',
    class SnkRequestModel extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('[data-snk-request]');
        const posted = /[?&]contact_posted=true/.test(location.search) && location.hash === '#SnkRequestForm';
        if (posted) this.showDone();
        else if (location.hash === '#SnkRequestForm' && this.querySelector('[data-snk-request-error]')) this.open(false);
        else if (location.hash === '#snk-request-model') this.open(true);
        window.addEventListener('hashchange', () => {
          if (location.hash === '#snk-request-model') this.open(true);
        });
      }

      open(focus) {
        if (!this.details) return;
        this.details.open = true;
        this.scrollIntoView({ block: 'start' });
        if (focus) this.querySelector('[data-snk-request-model]')?.focus({ preventScroll: true });
      }

      showDone() {
        if (this.details) this.details.hidden = true;
        const done = this.querySelector('[data-snk-request-done]');
        if (done) done.hidden = false;
        this.scrollIntoView({ block: 'start' });
      }
    }
  );
}
